import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
//import { Firebase } from '@ionic-native/firebase';


import { Platform } from 'ionic-angular';
import { Observable } from 'rxjs';
import { LoggingService } from '@varsity/services';
//import { AngularFirestore } from 'angularfire2/firestore';

/*
  Generated class for the FcmProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class FcmService {

    constructor(
        //public firebaseNative: Firebase,

        //public afs: AngularFirestore,
        private platform: Platform,
        private loggingService: LoggingService
    ) {
        console.log('Hello FcmProvider Provider');
    }

    getToken(): Observable<string> {
        return new Observable<string>(observer => {
            (window as any).FirebasePlugin.getToken((token) => {
                observer.next(token);
            });
        });

        //if (this.platform.is('android')) {
        //    token = await this.firebaseNative.getToken();
        //}

        //if (this.platform.is('ios')) {
        //    token = await this.firebaseNative.getToken();
        //    await this.firebaseNative.grantPermission();
        //}

        // TODO Is not cordova == web PWA
        //if (!this.platform.is('cordova')) {

        //}

        
        //return this.saveTokenToFirestore(token);
    }

    //private saveTokenToFirestore(token: any) {
    //    if (!token) {
    //        return;
    //    }

    //    const deviceRef = this.afs.collection('devices');
    //    const docData = {
    //        token,
    //        userId: 'testUser',

    //    }

    //    return deviceRef.doc(token).set(docData);

    //}

    onNotificationOpen(): Observable<any> {
        return new Observable(observer => {
            (window as any).FirebasePlugin.onMessageReceived((response) => {
                this.loggingService.debug("FCM: onNotificationOpen", response);
                observer.next(response);

            });
        });
    }

    grantPermission(): Observable<any> {
        return new Observable(observer => {
            this.loggingService.debug("FCM: call grantPermission");
            (window as any).FirebasePlugin.grantPermission((hasPermission) => {
                this.loggingService.debug("FCM: grantPermission: ", hasPermission);
                observer.next(hasPermission);
            });
        });
    }

    hasPermission(): Observable<any> {
        return new Observable(observer => {
            this.loggingService.debug("FCM: call hasPermission");
            (window as any).FirebasePlugin.hasPermission((hasPermission) => {
                this.loggingService.debug("FCM: hasPermission: ", hasPermission);
                observer.next(hasPermission);
            });
        });
    }

    onTokenRefresh(): Observable<string> {
        return new Observable(observer => {
            (window as any).FirebasePlugin.onTokenRefresh((token) => {
                this.loggingService.debug("FCM TOKEN REFRESHED", token);
                observer.next(token);
            });
        });
    };

    //grantPermission((hasPermission) => {
    //    return new Observable((observer) => {
    //        (window as any).FirebasePlugin.grantPermission((hasPermission) => {

    //        });
    //    })
    //});
    

    //listenToNotifications() {
    //    return this.firebaseNative.onNotificationOpen();
    //}


}



// WEBPACK FOOTER //
// ./src/services/fcm/fcm.service.ts